import { z } from "zod";
//
// Read
//
export const DTOElementPropertyValue = z.object({
    id: z.string(),
    designSystemVersionId: z.string(),
    definitionId: z.string(),
    targetElementId: z.string(),
    value: z.union([z.string(), z.number(), z.boolean()]).optional(),
    valuePreview: z.string().optional(),
});
export const DTOElementPropertyValueListResponse = z.object({
    values: z.array(DTOElementPropertyValue),
});
export const DTOElementPropertyValueResponse = z.object({
    value: DTOElementPropertyValue,
});
export const DTOElementPropertyValuesEditActionOutput = z.object({
    type: z.literal("ElementPropertyValuesEdit"),
    output: z.object({ success: z.literal(true) }),
});
//
// Write
//
export const DTOElementPropertyValueUpsertPaylod = z.object({
    definitionId: z.string(),
    targetElementId: z.string(),
    value: z.string().or(z.number()).or(z.boolean()).nullable(),
});
export const DTOElementPropertyValuesEditActionInput = z.object({
    type: z.literal("ElementPropertyValuesEdit"),
    values: DTOElementPropertyValueUpsertPaylod.array(),
});
